import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _templateObject,
    _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ImportEstimation/components/SubmitButton/SubmitButton.styled.ts",
    _templateObject2,
    _templateObject3;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { CircularProgress } from '@gmini/ui-kit/lib/CircularProgress';
import styled from 'styled-components';
export var SubmitButtonText = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  visibility: ", ";\n"])), function (props) {
  return props.hideText ? 'hidden' : 'initial';
});
export var IconSpinnerWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  position: absolute;\n  display: flex;\n"])));
export var IconSpinner = styled(CircularProgress)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: inherit;\n\n  margin: auto;\n\n  & svg {\n    width: 20px !important;\n    height: 20px !important;\n  }\n"])));